import React from 'react';

import { flagStyles } from '../settings';

const SvgHR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2304px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHR;
